import { createCpmsBoLocationSlice } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-location.slice';

import { cpmsBoLocationApi } from './cpms-bo-location.service';

export const cpmsBoLocationSlice = createCpmsBoLocationSlice({
  cpmsBoLocationApi,
});
